import { render, staticRenderFns } from "./BackhaulSubscriberSummary.vue?vue&type=template&id=09924019"
import script from "./BackhaulSubscriberSummary.vue?vue&type=script&lang=js"
export * from "./BackhaulSubscriberSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports